import {
    LEADERBOARD_REQUEST, LEADERBOARD_SUCCESS, LEADERBOARD_FAIL,
    LIVE_SCORES_REQUEST, LIVE_SCORES_SUCCESS, LIVE_SCORES_FAIL,
} from '../constants/leaderboardConstants'

export const leaderboardReducer = (state = { players: [] }, action) => {
    switch (action.type) {
        case LEADERBOARD_REQUEST:
            return { loading: true, players: [] }
        case LEADERBOARD_SUCCESS:
            return { loading: false, players: action.payload }
        case LEADERBOARD_FAIL:
            return { loading: false, error: action.payload, players: [] }
        default:
            return state
    }
}

export const liveScoresReducer = (state = { tournaments: [], loading: false }, action) => {
    switch (action.type) {
        case LIVE_SCORES_REQUEST:
            return { ...state, loading: true }
        case LIVE_SCORES_SUCCESS:
            return { loading: false, tournaments: action.payload }
        case LIVE_SCORES_FAIL:
            return { loading: false, error: action.payload, tournaments: [] }
        default:
            return state
    }
}

